import ControllerAbstract from './ControllerAbstract';

// The logout page is public: unlike the AppController based ones it must not load the session or any API data
class LogoutPageController extends ControllerAbstract {}

export default LogoutPageController;
